export const expandCollapse = () => {
  var acc = document.getElementsByClassName("leermas")
  var i

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      var panel = this.previousElementSibling
      if (panel.style.maxHeight) {
        this.innerHTML = "...(Lee más)"
        document.documentElement.scrollTop = this.parentNode.offsetTop - 100
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        this.innerHTML = "...(Menos)"
      }
    });
  }
}
